import { useState } from 'react'
import { Label } from '@/shared/components/ui/label'
import { Checkbox } from '@/shared/components/ui/checkbox'

type ToggleCardProps = {
    id: string
    titleEnabled: string
    titleDisabled?: string
    description?: string
    checked: boolean
    onChange?: (checked: boolean) => void
}

export const ToggleCard = ({
    id,
    titleEnabled,
    titleDisabled,
    description,
    checked,
    onChange,
}: ToggleCardProps) => {
    const handleChange = (value: boolean) => {
        onChange?.(value)
    }

    return (
        <Label
            className={`hover:bg-accent/50 flex items-start gap-3 rounded-lg border p-3
        has-[[aria-checked=true]]:border-slate-600 has-[[aria-checked=true]]:bg-slate-100
        dark:has-[[aria-checked=true]]:border-slate-700 dark:has-[[aria-checked=true]]:bg-slate-900`}
        >
            <Checkbox
                id={id}
                checked={checked}
                onCheckedChange={(v) => handleChange(!!v)}
                className="data-[state=checked]:border-slate-600 data-[state=checked]:bg-slate-900 data-[state=checked]:text-white 
                   dark:data-[state=checked]:border-slate-400 dark:data-[state=checked]:bg-slate-400"
            />
            <div className="grid gap-1.5 font-normal">
                <p className="text-sm leading-none font-medium">
                    {checked ? titleEnabled : titleDisabled ?? titleEnabled}
                </p>
                {!checked && description && (
                    <p className="text-muted-foreground text-xs">{description}</p>
                )}
            </div>
        </Label>
    )
}
